import styled from '@emotion/styled';
import { Button, Typography } from 'antd';

const Row = styled.div<{
    gap?: number | boolean,
    between?: boolean,
    marginBottom?: number,
}>`
    display:flex;
    align-items:center;
    justify-content: ${props => props.between? "space-between" : undefined};
    margin-bottom: ${props => props.marginBottom + 'rem'};
    > * {
        margin-top: 0!important;
        margin-bottom: 0!important;
        margin-right: ${props => typeof props.gap === 'number' ? props.gap + 'rem' : props.gap? '2rem' : undefined};
    }
`

export {
    Row
}

export const NoPaddingButton = styled(Button)`
  padding: 0;
`;

// type guard
const isError = (value:any): value is Error => value?.message
export const ErrorBox = ({error}:{error?:unknown}) => {
    if (isError(error)) {
        return <Typography.Text type='danger'>{error?.message}</Typography.Text>
    }
    return null
}

export const ScreenContainer = styled.div`
  padding: 3.2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
`;